export enum CHECKOUT_ROUTES {
  DELIVERY = '/delivery',
  COMPLETE = '/complete',
  PAYMENT = '/payment',
  CASH_APP_PAY = '/cash_app_pay',
}

export enum CompleteOrderError {
  GENERIC = 'generic',
  PAYMENT = 'payment',
  PRE_AUTH = 'pre_auth',
  // Seller card save failures on completion; tracked as payment errors.
  CARD_VERIFICATION_REQUIRED = 'card_verification_required',
  CARD_SOURCE_UNUSABLE = 'card_source_unusable',
  CARD_SAVE_FAILED = 'card_save_failed',
  // Saved card the buyer doesn't own; tracked as a general error.
  SAVED_CARD_NOT_OWNED = 'saved_card_not_owned',
}
